export const DEFAULT_OPTIMIZATION_FOR_PV = 100;
